// extracted by mini-css-extract-plugin
module.exports = {"imageThumbnail":"UploadedFileList_imageThumbnail__1_EUd","actionButton":"UploadedFileList_actionButton__2hK3J"};